import { Component, HostBinding } from '@angular/core';
import { SettingsNavigationContentComponent } from '../../../../models/settings-navigation-content-component';
import { Endpoint, HelpIndex, SettingsType } from '../../../../models/enums';
import { GenericTreeNode } from '../../../generic-tree/generic-tree-node';
import { CommonService } from '../../../../services/common/common.service';
import { RestService } from '../../../../services/rest/rest.service';
import { ActionType, ObjectActionListType, Permissions } from '../../../../models/permission';
import { isNullOrUndefined } from '../../../../models/utils';

@Component({
	standalone: false,
	selector: 'res-project-configuration',
	templateUrl: './project-configuration.component.html',
	styleUrls: ['./project-configuration.component.scss']
})
export class ProjectConfigurationComponent implements SettingsNavigationContentComponent {
	@HostBinding('class') classes = 'maximized-component';

	isDirty: boolean;
	hasAddEditPermission: boolean;
	isConflictCheckComplete: boolean;
	lastCheckedDateTime: string;
	projectHandle: string;
	isDateLabelHidden = true;
	isBusy = false;
	isBusyMessage = 'Loading Project Configuration...';
	validChanges = true;
	originalConflictCheckFlag: boolean;

	constructor(private commonService: CommonService,
		private restService: RestService) {
	}

	saveChanges(autoSaveChanges?: boolean): Promise<boolean> {
		return new Promise<boolean>((resolve) => {
			if (this.projectHandle) {
				this.isBusy = true;
				this.isBusyMessage = 'Saving Project Configuration...';
				this.restService.post(Endpoint.projectManager_setTLSProjectConfiguration, {
					projectHandle: this.projectHandle,
					tlsProjectConfiguration: {
						conflictCheckCompleted: this.isConflictCheckComplete,
						lastRunTime: this.isConflictCheckComplete ? Date.now().toString() : this.lastCheckedDateTime
					}
				}).then((response) => {
					this.isBusy = false;
					resolve(true);
					this.isDirty = false;
					if (response?.tlsProjectConfiguration) {
						this.lastCheckedDateTime = response.tlsProjectConfiguration.lastRunTime;
					}
				}, () => {
					resolve(false);
					this.isBusy = false;
				});
			} else {
				resolve(false);
			}
		});
	}

	discardChanges(): void {
		this.isDirty = false;
		this.loadData();
	}

	selectedTreeItemChanged(node: GenericTreeNode, projectHandle?: string, settingsType?: SettingsType): void {
		this.projectHandle = projectHandle;
		this.hasAddEditPermission = Permissions.checkUserPermission(ObjectActionListType.TLS_PROJECT_CONFIG, ActionType.CREATE);
		this.loadData();
	}

	loadData(): void {
		if (this.projectHandle) {
			this.isBusy = true;
			this.restService.post(Endpoint.projectManager_getTLSProjectConfiguration, { handle: this.projectHandle }).then((response) => {
				if (response?.tlsProjectConfiguration) {
					this.isConflictCheckComplete = this.originalConflictCheckFlag = !isNullOrUndefined(response.tlsProjectConfiguration.conflictCheckCompleted) ? response.tlsProjectConfiguration.conflictCheckCompleted : false;
					this.lastCheckedDateTime = response.tlsProjectConfiguration.lastRunTime;
					this.isDateLabelHidden = !this.isConflictCheckComplete;
				}
				this.isBusy = false;
			}, () => { this.isBusy = false; });
		}
	}

	onCheckboxChanged() {
		this.isDirty = this.isConflictCheckComplete !== this.originalConflictCheckFlag;
		this.isDateLabelHidden = !this.isConflictCheckComplete;
	}

	isDisabled(): boolean {
		let isDisabled = true;
		if ((!this.isBusy && this.isDirty) || !this.hasAddEditPermission) {
			isDisabled = false;
		}
		return isDisabled;
	}

	//openHelp = () => this.commonService.openHelp(HelpIndex.admin_manage_settings_dlg);
}
